import {
  platformCookieValueWebView,
  platformIdentifierCookieName,
} from '@onyx/constants';

import { getCookie } from './get-cookie';
import type { CtxWithNextRequest } from './types';

export const isWebView = (ctx?: CtxWithNextRequest) => {
  const platformCookie = getCookie(platformIdentifierCookieName, { ctx });
  return platformCookie === platformCookieValueWebView;
};
